<template>
  <div>
    <el-drawer title="补扣款明细" :visible.sync="drawer" direction="rtl" size="88%">
      <div class="w-full pl-6 pb-2 pt-6 bg-theme-gray">
        <SearchCard
          ref="searchCard"
          :searchConfig="isInvestigator ? searchConfig : searchConfigProxy"
          class="bg-white-input"
          @to-search="toSearch"
          @on-reset="onReset"
        />
      </div>
      <div class="p-4">
        <data-table
          ref="crud"
          align="left"
          height="504"
          :columns="isInvestigator ? column : columnProxy"
          :data="tableData"
          :showPage="true"
          :page="pagination"
          @size-change="sizeChange"
          @pagination-current-change="currentChange"
        >
          <template #adjustYuanAmount="{ row }">
            <span>{{ row.adjustYuanAmount | getAdjustYuanAmountText }}</span>
          </template>
          <template #expectedYuanAmount="{ row }">
            <span>{{ (row.expectedYuanAmount || row.expectedYuanAmount === 0) && row.expectedYuanAmount.toFixed(2) }}</span>
          </template>
          <template #operationalYuanAmount="{ row }">
            <span>{{
              (row.operationalYuanAmount || row.operationalYuanAmount === 0) && row.operationalYuanAmount.toFixed(2)
            }}</span>
          </template>
        </data-table>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import SearchCard from './SearchCard'
import StatisticalCard from './StatisticalCard.vue'
import DataTable from '@/components/base/DataTable'
import { getSetAdjustPage } from '@/api/cost-settlement/settlement-initiate/submitStatement'
import { SETTLE_OBJ_TYPE } from '../settleConst'

export default {
  name: 'DetailDrawer',
  components: { SearchCard, StatisticalCard, DataTable },
  props: {
    sid: {
      type: [Number, String],
      default: ''
    }
  },
  filters: {
    getAdjustYuanAmountText(v) {
      if (v > 0) {
        return '+' + v.toFixed(2)
      } else {
        return v.toFixed(2)
      }
    }
  },
  computed: {
    getParams() {
      return {
        ...this.searchData,
        current: this.pagination.currentPage,
        size: this.pagination.pageSize,
        statementId: this.statementId,
        settleObjType: this.settleObjType
      }
    },
    statementId() {
      return this.$route.query.statementId ?? this.$route.params.id ?? this.sid
    },
    settleObjType() {
      return this.$route.query.settleObjType ?? SETTLE_OBJ_TYPE.INVESTIGATOR
    },
    isInvestigator() {
      return this.settleObjType == SETTLE_OBJ_TYPE.INVESTIGATOR
    },
    columnProxy() {
      const proxyItem = [
        {
          label: '代理名称',
          value: 'investigatorName'
        }
      ]
      const operationalYuanAmount = {
        label: '结算总费用(元)',
        value: 'operationalYuanAmount',
        // headName: 'operationalYuanAmountHead',
        align: 'right'
        // width: 100,
      }
      return proxyItem.concat(this.column.slice(2, 4), operationalYuanAmount)
    }
  },
  data() {
    return {
      tableData: [],
      pagination: {
        pageSize: 20,
        currentPage: 1,
        total: 0
      },
      drawer: false,
      column: [
        {
          label: '调查员',
          value: 'investigatorName'
          // width: 60,
        },
        {
          label: '手机号码',
          value: 'investigatorPhone'
          // width: 100,
        },
        {
          label: '补扣款(元)',
          value: 'adjustYuanAmount'
          // width: 60,
        },
        {
          label: '补扣款原因',
          value: 'adjustDescribe',
          width: 200
        },
        {
          label: '到手金额(元)',
          value: 'expectedYuanAmount',
          width: 120
        }
      ],
      searchConfig: [
        {
          prop: 'investigatorName',
          placeholder: '请输入调查员'
        },
        {
          prop: 'investigatorPhone',
          placeholder: '请输入手机号'
        }
      ],
      searchConfigProxy: [
        {
          prop: 'investigatorName',
          placeholder: '请输入代理名称'
        }
      ],
      searchData: {}
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      if (!['', undefined, null].includes(this.statementId)) {
        getSetAdjustPage(this.getParams).then(res => {
          const { code, msg, data } = res?.data || {}
          if (code === 0) {
            const { records, total } = data || {}
            this.tableData = records || []
            this.pagination.total = total ?? 0
          } else {
            this.$message.error(msg ?? '获取列表数据失败')
          }
        })
      }
    },
    toSearch(v) {
      this.searchData = v
      this.getList()
    },
    onReset() {
      this.searchData = {}
      this.getList()
    },
    sizeChange(v) {
      this.pagination.currentPage = 1
      this.pagination.pageSize = v
      this.getList()
    },
    currentChange(v) {
      this.pagination.currentPage = v
      this.getList()
    },
    open() {
      this.drawer = true
      this.$refs.searchCard?.clearData()
      this.onReset()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-drawer__header {
  @apply bg-white;
}
::v-deep .el-drawer__body {
  @apply p-6;
}
</style>
